module.exports = __webpack_public_path__ + "img/not-result.efde41fd.svg";